import React, { useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import useReactRouter from "use-react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import * as _ from "lodash";
import { useInitFbSDK } from "../../../helpers/fb-hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faPen,
  faVideo,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { errorTitleWithTextSwal } from "../../../helpers/sweetalert";
import moment from "moment";
import Swal from "sweetalert2";
import { useToasts } from "react-toast-notifications";
// import AnimationLoading from "../../../components/AnimationLoading";
import "../liveScreen/liveScreen.css";
import { GET_LIVES } from "../../../graphql/live/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { DELETE_LIVE, UPDATE_LIVE } from "../../../graphql/live/mutation";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import { SHOP } from "../../../graphql/shop/queryShop"; 
import {
  // END_LIVE,
  END_LIVE_V2,
  SEND_NOTI_TO_CUSTOMER,
  // UNSUBSCRIBE_LIVE,
  UNSUBSCRIBE_LIVE_V2,
} from "../../../graphql/liveManage/subscribeLive";
import { convertLiveStatus } from "../../../helpers/liveStatus";
import { connect } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import { COLOR_APP, CREATED, LINK_SALE_PAGE, ONAIR, PROCESSING } from "../../../constants";
import BasicModal from "../../../components/BasicModal";
import SuccessModal from "../../../components/SuccessModal";
import PaginationHelper from "../../../helpers/PaginationHelper";
import Illustration from "../../../image/Illustration.png";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import copy from "clipboard-copy";
// import { FaCopy } from "react-icons/fa";
import Cookies from 'js-cookie';
import LoadingSpinner from "../../../components/LoadingSpinner";

function LiveActive({ }) {
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const isFbSDKInitialized = useInitFbSDK();
  const { height, width } = useWindowDimensions();

  const LIMIT_PAGE = 30;
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  // App state
  const [fbUserAccessToken, setFbUserAccessToken] = useState();
  const [liveList, setLiveList] = useState([]);
  const [liveTotal, setLiveTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [currentStatus, setCurrentStatus] = useState("ALL");
  const [showDeleteLiveConfirm, setShowDeleteLiveConfirm] = useState(false);
  const [showDeleteLiveSuccess, setShowDeleteLiveSuccess] = useState(false);
  const [shopValidated, setShopValidated] = useState();
  const [liveShopStockForValidate, setLiveShopStockForValidate] = useState();

  //ERROR CHECK
  const [selectedLive, setSelectedLive] = useState();
  const [isContinue, setIsContinue] = useState(false);

  //Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  const [selectedPage, setSelectedPage] = useState();
  const [selectedPageName, setSelectedPageName] = useState("");
  const [selectedPageId, setSelectedPageId] = useState("");
  const [selectedPageToken, setSelectedPageToken] = useState("");


  const [getLivesData, { data: livesData }] = useLazyQuery(GET_LIVES, {
    fetchPolicy: "cache-and-network",
  });
 
  const [getLiveShopStockForValidate, { data: liveShopStockDataForValidate }] =
    useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getShop, { data: shopValidatedData }] = useLazyQuery(SHOP, {
    fetchPolicy: "cache-and-network",
  });



  const [deleteLive, { loading: deleteLiveLoading }] = useMutation(DELETE_LIVE);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [updateLive, { loading: updateLiveLoading }] = useMutation(UPDATE_LIVE);
  // const [unsubscribeLive] = useMutation(UNSUBSCRIBE_LIVE);
  const [unsubscribeLive] = useMutation(UNSUBSCRIBE_LIVE_V2);
  // const [endLiveVDO, { loading: endLiveLoading }] = useMutation(END_LIVE);
  const [endLiveVDO, { loading: endLiveLoading }] = useMutation(END_LIVE_V2);
  const [sendNotiToCustomer] = useMutation(SEND_NOTI_TO_CUSTOMER);

  useEffect(() => {
    // onNextOrBackPage();
    // getLives();
    getFacebookLoginStatus();
    window.onpopstate = () => {
      // onNextOrBackPage();
      // getLives();
    };
  }, []);

  useEffect(() => {
    // onNextOrBackPage();
    getLives();
  }, [_skip]);

  // Checks if the user is logged in to Facebook
  React.useEffect(() => {
    // console.log("window.FB: ", window.FB)
    if (isFbSDKInitialized) {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse?.accessToken);
        else
          errorTitleWithTextSwal(
            "ມີຂໍ້ຜິດພາດ",
            "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
          );
      });
    }
    // getLives();
  }, [isFbSDKInitialized]);

  useEffect(() => {
    if (shopValidatedData) {
      // setShopValidated(false)
      //Check error point
      if (shopValidatedData?.shop?.paymentType == "POINT") {
        if (shopValidatedData?.shop?.point <= 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ຄະແນນຂອງທ່ານບໍ່ພຽງພໍ!",
            html:
              `<div className="text-left">ກະລຸນາເຕີ່ມຄະແນນກ່ອນ ຈຶ່ງສາມາດເລີ່ມຕໍ່ການ Live ໄດ້ <br/>` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      //Check If Subscription period
      if (shopValidatedData?.shop?.paymentType == "SUBSCRIPTION") {
        if (moment().diff(shopValidatedData?.shop?.endDate, "days") > 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ໄລຍະເວລາການໃຊ້ງານຂອງທ່ານສິ້ນສຸດແລ້ວ!",
            html:
              `<div className="text-left">` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      /**
       * Check live product is not delete from warehouse
       */
      getLiveShopStockForValidate({
        variables: {
          where: {
            live: selectedLive?.id,
          },
        },
      }).then(() => setLiveShopStockForValidate(!liveShopStockForValidate));
    }
  }, [shopValidated]);

  useEffect(() => {
    try {
      if (liveShopStockDataForValidate) {
        /**
         * Check if live has no liveproduct will not allow to start live
         */
        let _liveStockList = liveShopStockDataForValidate?.liveStocks?.data;

        if (_liveStockList?.length == 0) {
          Swal.fire({
            icon: "error",
            title: "ບໍ່ມີສິນຄ້າທີ່ຈະຂາຍໃນໄລຟ",
            html:
              `<div className="text-left">STEP1: ເພີ່ມສິນຄ້າທີ່ຈະຂາຍໃນໄລຟນີ້ກ່ອນ<br/>` +
              "STEP2 : ເລີ່ມໄລຟຂາຍເຄື່ອງໄດ້ເລີຍ <br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        /**
         * Check if stock does not exist in warehouse
         */
        let checkStockExistError = false;
        _liveStockList.map(async (lProduct) => {
          // console.log({ lProduct })
          if (lProduct?.stock?.isDeleted) {
            checkStockExistError = true;
          }
        });
        if (checkStockExistError) {
          Swal.fire({
            icon: "error",
            title: "ມີສິນຄ້າທີ່ຖືກລຶບອອກຈາກສະຕ໊ອກແລ້ວໃນໄລຟນີ້",
            html:
              `<div className="text-left">STEP1: ແກ້ໄຂໄລຟນີ້ ຫຼື ສ້າງໄລຟໃຫມ່<br/>` +
              "STEP2 : ລຶບສິນຄ້ານັ້ນອອກ <br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        /**
         * Check if no page selected
         */
        if (!selectedLive?.page) {
          Swal.fire({
            icon: "error",
            title: "ເລືອກເພຈທີ່ທ່ານຕ້ອງການໄລຟສົດ",
            html:
              `<div className="text-left">STEP1: ເລືອກເພຈທີ່ຕ້ອງການໄລຟໃສ່ກັບຂໍ້ມູນທີ່ສ້າງມາ <br/>` +
              "" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        _checkFbLiveAndGo();
      }
    } catch (err) {
      console.log("Error in go to live screen(2)", err);
      setIsLoading(false);
      addToast("ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  }, [liveShopStockForValidate]);

  useEffect(() => {
    if (livesData?.lives) {
      setIsLoading(false);
      setLiveList(livesData?.lives?.data);
      setLiveTotal(livesData?.lives?.total);
      setPageCountNumber(parseInt(livesData?.lives?.total / LIMIT_PAGE) + 1);
    }
  }, [livesData]);

 

  const getLives = async () => {
    try {
      setLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getLivesData({
        variables: {
          where: {
            shop: SHOP_ID,
            isDeleted: false,
            status: [ONAIR, CREATED, PROCESSING],
          },
          limit: _limit,
          skip: _limit * (_skip - 1),
          orderBy: "createdAt_DESC",
        },
      });
      // await getShopSetting({
      //     variables: {
      //         where: {
      //             shop: SHOP_ID,
      //         },
      //         orderBy: "createdAt_ASC"
      //     },
      // });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error retrieving posts", error);
    }
  };

  const onNextOrBackPage = async () => {
    try {
      setIsLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");

      let _where = {
        shop: SHOP_ID,
        isDeleted: false,
        status: [ONAIR, CREATED, PROCESSING],
      };

      //check if status is selected
      if (currentStatus != "ALL") {
        _where = {
          ..._where,
          status: currentStatus,
        };
      }

      await getLivesData({
        variables: {
          where: _where,
          limit: LIMIT_PAGE,
          skip: LIMIT_PAGE * (pageNumber - 1),
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  }; 

  const getFacebookLoginStatus = () => {
    try {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse.accessToken);
      });
    } catch (error) {
      console.log("Error FACEBOOK STATUS", error);
    }
  };

  const _fbGetUserToken = () =>
    new Promise((resolve) => {
      // Browsers that block Facebook cookies may never call back; fall through to the
      // stored tokens instead of leaving the loading spinner up.
      setTimeout(() => resolve(undefined), 8000);
      try {
        // `true` forces a round trip so the SDK hands back a refreshed token.
        window.FB.getLoginStatus(
          (response) => resolve(response?.authResponse?.accessToken),
          true
        );
      } catch (error) {
        resolve(undefined);
      }
    });

  const _fbApi = (path) =>
    new Promise((resolve) => {
      try {
        window.FB.api(path, (response) => resolve(response));
      } catch (error) {
        resolve({ error: { message: error?.message } });
      }
    });

  const _getCookiePageList = () => {
    try {
      const shopPageCookie = Cookies.get("SHOP_PAGE");
      if (shopPageCookie) return JSON.parse(shopPageCookie);
      const shopPageLocal = localStorage.getItem("SHOP_PAGE");
      if (shopPageLocal) return JSON.parse(shopPageLocal);
    } catch (error) {
      console.log("Error reading SHOP_PAGE", error);
    }
    return [];
  };

  const _showFbPageError = (title) => {
    setIsLoading(false);
    Swal.fire({
      icon: "error",
      title,
      html:
        `<div className="text-left">STEP1: ກົດ ຍົກເລີກການເຊື່ອມຕໍ່ Facebook ຢູ່ມຸມຂວາເທິງ <br/>` +
        "STEP2 : ກົດ ເຊື່ອມຕໍ່ກັບ Facebook ໃຫມ່ ແລ້ວເລືອກເພຈທີ່ຕ້ອງການໄລຟ (ບັນຊີຕ້ອງເປັນແອັດມິນຂອງເພຈ)<br/>" +
        "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວລອງໃຫມ່ອີກຄັ້ງ</div>",
      showConfirmButton: false,
      timer: 20000,
    });
  };

  /**
   * Find the Facebook live on the selected page and open the live screen.
   *
   * The page tokens in the SHOP_PAGE cookie come from a short-lived user token, so they
   * die after ~1-2h and are only replaced on reload or reconnect. A long live that drops
   * and is continued hours later used to send that dead token to Facebook and fail with
   * "reconnect Facebook" although nothing was wrong. So the token is resolved at click
   * time: a fresh one from the SDK first and the cookie one as the fallback, each tried
   * until Facebook accepts it.
   */
  const _checkFbLiveAndGo = async () => {
    try {
      const pageId = selectedLive?.page;

      let freshPageList = [];
      const userToken = await _fbGetUserToken();
      if (userToken) {
        const accounts = await _fbApi(
          `/me/accounts?fields=id,name,access_token&limit=100&access_token=${userToken}`
        );
        if (accounts?.error) console.log("FB ERROR /me/accounts:", accounts.error);
        else freshPageList = accounts?.data || [];
      }

      const freshPage = _.find(freshPageList, { id: pageId });
      const cookiePage = _.find(_getCookiePageList(), { id: pageId });
      const page = freshPage || cookiePage;

      if (!page) {
        if (!userToken) {
          return _showFbPageError("ກະລຸນາເຊື່ອມຕໍ່ກັບ Facebook ກ່ອນ!");
        }
        if (freshPageList.length === 0) {
          return _showFbPageError("Facebook ບໍ່ໄດ້ສົ່ງລາຍຊື່ເພຈມາໃຫ້ລະບົບ");
        }
        return _showFbPageError("ບັນຊີ Facebook ນີ້ບໍ່ມີສິດເຂົ້າເຖິງເພຈຂອງໄລຟນີ້");
      }

      const tokens = _.uniq(
        [freshPage?.access_token, cookiePage?.access_token].filter(Boolean)
      );
      let response;
      let accessToken;
      for (const token of tokens) {
        response = await _fbApi(
          `/${page.id}/videos?fields=title,id,description,permalink_url,status,live_status,broadcast_status&access_token=${token}`
        );
        if (!response?.error) {
          accessToken = token;
          break;
        }
        console.log("FB ERROR:", response.error);
      }

      if (!accessToken) {
        setIsLoading(false);
        const code = response?.error?.code;
        addToast(
          `ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!${code ? ` (code ${code})` : ""}`,
          {
            appearance: "warning",
            autoDismiss: true,
          }
        );
        return;
      }

      console.log("** Call update live api cf");
      for (const vdo of response?.data || []) {
        if (vdo?.status === "LIVE" || vdo?.live_status === "LIVE") {
          // New version 2025-11-14  get new video id from vdo
          const url = new URL("https://facebook.com" + (vdo?.permalink_url || ""));
          const videoId = url.pathname.split("/").filter(Boolean).pop();
          const isSuccess = await _editLive(vdo, accessToken);
          setIsLoading(false);
          if (!isSuccess) return;
          // Redirect ທັນທີຫຼັງຈາກສຳເລັດ ແລະ ສົ່ງ state ໄປພ້ອມ
          history.push(`/live-screen/${selectedLive?.id}`, {
            live: selectedLive,
            page: { ...page, access_token: accessToken },
            access_token: accessToken,
            fbLiveId: videoId || vdo?.id,
            isContinue,
          });
          return;
        }
      }

      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
        html:
          `<div className="text-left">STEP1: ໄປທີ່ page (${page.name}) <br/> ` +
          "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
          "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
        showConfirmButton: false,
        timer: 20000,
      });
    } catch (err) {
      console.log("Error in go to live screen", err);
      setIsLoading(false);
      addToast("ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const _goLiveScreen = async (live, isContinueA) => {
    setIsLoading(true);
    const _checkPoint = await checkPoint();
  };

  const _editLive = async (_fbLive, access_token) => {
    try {
      // _fbLive?.permalink_url = 854481546383471/videos/1837505667138775
      const url = new URL('https://facebook.com' + (_fbLive?.permalink_url || ''));
      const videoId = url.pathname.split('/').filter(Boolean).pop();
      await updateLive({
        variables: {
          where: {
            id: selectedLive.id,
          },
          data: {
            status: "ONAIR",
            // fbLiveId: _fbLive.id,
            fbLiveId: videoId || _fbLive.id,
            description: _fbLive.description,
            pageAccessToken: access_token,
            videoLink: "https://facebook.com" + _fbLive?.permalink_url,
          },
        },
      });
      return true;
    } catch (err) {
      console.log("Error subscribe live");
      console.error("Error in _editLive:", err);
      if (err.message === "LIVE_WITH_SAME_FB_LIVE_ID_ALREADY_ON_AIR"){
        console.log("❌❌ Live ມີການຊ້ຳ fb live id ດຽວກັນແລ້ວ ❌❌");
        console.log("✅✅ ກົດສືບຕໍ່. ຫລື ສີ້ນສຸດ Live ກ່ອນຫນ້ານີ້. ເລີ່ມໄລນໃຫມ່ ✅✅");
        Swal.fire({
          icon: "error",
          title: "ເກີດຂໍຜີດພາດພະຍາຍາມ ສ້າງໄລນຊຳກັນ!",
          html:
            `<div className="text-left"> ❌❌ຜິດພາດ! ບໍ່ສາມາດເລີ່ມໄລນ. ທີ່ຊຳກັນ! ກະລຸນາກວດເຊັກໄລນກ່ອນຫນ້ານີ້❌❌ <br/> ` +
            "✅✅ ກົດສືບຕໍ່. ຫລື ສີ້ນສຸດ Live ກ່ອນຫນ້ານີ້. ແລ້ວຄ່ອຍເລີ່ມໄລນໃຫມ່ ✅✅ <br/>",
          showConfirmButton: false,
          timer: 20000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "ເກີດຂໍ້ຜິດພາດທີ່ບໍ່ຄາດຄີດ!",
          html:
            `<div className="text-left">❌❌ ກະກວດສອບຂໍຜີດຜາດ ❌❌<br/> ` +
            "✅✅ ຫລື ຕີດຕໍ່ຜູ້ໃຫ້ບໍລິການ ✅✅ <br/>",
          showConfirmButton: false,
          timer: 20000,
        });
      }
      return false;
    }
  };

  const _endLive = async (_live) => {
    try {
      // const shopPageCookie = Cookies.get('SHOP_PAGE');
      // const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
      // const assignedPageList = JSON.parse(Cookies.get('SHOP_PAGE'));
      // const assignedPageList = JSON.parse(localStorage.getItem('SHOP_PAGE'));
      setIsLoading(true);
      if (endLiveLoading || isLoading) return;
      // let _setSelectedOrderPage = assignedPageList?.filter(
      //   (_page) => _page.id === _live.page
      // );

      let endError = false;
      await endLiveVDO({
        // variables: {
        //   id: _live?.id,
        //   fbLiveId: _live.fbLiveId,
        //   page_access_token: _setSelectedOrderPage[0]?.access_token ?? "",
        // },
        variables: {
          id: _live?.id
        },
      }).catch((err) => {
        console.log(err);
        addToast("ຜິດພາດ, ບໍ່ສາມາດສິ້ນສຸດໄລຟນີ້ໄດ້!", {
          appearance: "warning",
          autoDismiss: true,
        });
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        console.log("endLiveVDO error");
        endError = true;
        return;
      });
      if (endError) return;

      await unsubscribeLive({
        // variables: {
        //   id: _live?.id,
        //   fbLiveId: _live.fbLiveId,
        //   page_access_token: _setSelectedOrderPage[0].access_token ?? "",
        // },
        variables: {
          fbLiveId: _live.fbLiveId
        },
      }).catch((err) => {
        console.log(err);
        addToast("ຜິດພາດ, ບໍ່ສາມາດຍົກເລີກການ Subscribe!", {
          appearance: "warning",
          autoDismiss: true,
        });
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        endError = true;
        return;
      });
      if (endError) return;

      addToast("ສິ້ນສຸດການໄລຟນີ້ແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
      let _liveList = [...liveList];
      _.remove(_liveList, { id: _live?.id });
      setLiveList(_liveList);
      setTimeout(() => {
        setIsLoading(false);
        window.location.reload();
      }, 2000);
    } catch (err) {
      console.log("Error in end live:", err);
      addToast("ເກີດຊໍ້ຜິດຜາດທີ່ບໍ່ຄາດຄີດ, ບໍ່ສາມາດສິ້ນສຸດໄລຟນີ້ໄດ້!", {
        appearance: "error",
        autoDismiss: true,
      });
      // setTimeout(() => {
      //   setIsLoading(false);
      //   window.location.reload();
      // }, 2000);
      return;
    }
  };

  const checkPoint = async () => {
    try {
      const SHOP_ID = localStorage.getItem("SHOP");
      await getShop({
        variables: {
          where: {
            id: SHOP_ID,
          },
        },
      }).then(() => setShopValidated(!shopValidated));
    } catch (error) {
      console.log("error: ", error);
    }
  };
 

  const _deleteLive = async () => {
    if (deleteData) {
      try {
        if (deleteLiveLoading || isLoading) return;
        setIsLoading(true);
        await deleteLive({
          variables: {
            where: {
              id: deleteData?.id,
            },
          },
        });
        let _liveList = [...liveList];
        _.remove(_liveList, { id: deleteData?.id });
        setLiveList(_liveList);
        setIsLoading(false);
        setShowDeleteModal(false);
        addToast("ລຶບໄລຟສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setDeleteData();
        // window.location.reload();
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    }
  };

  const _sendNotiToCustomer = async () => {
    try {
      sendNotiToCustomer({
        variables: {
          shopId: selectedPage?.shop?.id,
          accessToken: selectedPageToken,
          pageId: selectedPageId,
          pageName: selectedPageName,
        },
      });
      addToast("ສົ່ງແຈ້ງເຕືອນຫາລູກຄ້າແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const handleDeleteLive = async () => {
    await _deleteLive();
    await triggerHideDeleteLiveConfirm();

    triggerShowDeleteLiveSuccess();
    setTimeout(() => {
      triggerHideDeleteLiveSuccess();
    }, 1500);
  };

  const triggerShowDeleteLiveConfirm = () => setShowDeleteLiveConfirm(true);
  const triggerHideDeleteLiveConfirm = () => setShowDeleteLiveConfirm(false);
  const triggerHideDeleteLiveSuccess = () => setShowDeleteLiveSuccess(false);
  const triggerShowDeleteLiveSuccess = () => setShowDeleteLiveSuccess(true);

  const handleCopyLinkLive = async (live) => {
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    const _getLiveId = live?.id;
    const tabLive = "LIVE";
    const url = LINK_SALE_PAGE + `/shop/${shopId}/${_getLiveId}/${tabLive}`;

    try {
      await copy(url);
      addToast("ກ໋ອບປີ່ລິ້ງສຳເລັດແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.error("Copy failed: ", error);
    }
  };

  // if (loading || isLoading) {
  //   return <AnimationLoading />;
  // }

  return (
    <div style={{ padding: 0, margin: 0 }}>
      {(loading || isLoading) ? <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
        <LoadingSpinner />
      </div>
        : liveList?.length === 0 ? (
          <div className="no_data">
            <img src={"/images/no_data.png"} alt="" />
            <h1>ບໍ່ມີຂໍ້ມູນ</h1>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Table
              responsive
              // className="staff-table-list borderless table-hover"
              style={{
                marginTop: "20px",
                // borderCollapse: "collapse",
                width: "100% ",
              }}>
              <thead
                style={{
                  borderColor: "#fff",
                }}>
                <tr style={{ whiteSpace: "nowrap" }}>
                  <th style={{ border: "none" }}>ລຳດັບ</th>
                  <th style={{ border: "none" }}>ຫົວຂໍ້ໄລຟ</th>
                  <th style={{ border: "none" }}>ເພຈເຊື່ອມຕໍ່</th>
                  <th style={{ border: "none" }}>ສະຖານະ</th>
                  <th style={{ border: "none" }}>ວັນເວລາ</th>
                  <th style={{ border: "none" }}>ຈັດການ</th>
                </tr>
              </thead>
              <tbody>
                {liveList.map((live, index) => (
                  <tr
                    id="trActionCell"
                    key={live + index}
                    style={{ verticalAlign: "middle" }}>
                    <td style={{ width: "45px" }} className="index">
                      {index + 1}
                    </td>
                    <td style={{ width: "327px", minWidth: 200 }}>
                      {live?.description || "ຍັງບໍ່ກໍານົດ"}
                    </td>
                    <td style={{ width: "238px",minWidth: 240 }}>{live?.pageName}</td>
                    <td >
                      <div
                        className="status"
                        style={{
                          color: COLOR_APP,
                          fontSize: 16,
                          whiteSpace: "nowrap",
                          border: "1px solid " + COLOR_APP,
                          padding: "5px",
                        }}>
                        {convertLiveStatus(live?.status)}
                      </div>
                    </td>
                    <td style={{minWidth: 180}}>{moment(live?.createdAt).format("DD/MM/YYYY  HH:mm")}</td>
                    <td>
                      {live.status === ONAIR ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <CustomButton
                            onClick={() => {
                              _endLive(live);
                            }}
                            endCameraIcon
                            text={"ສິ້ນສຸດ"}
                          />
                          <button
                            onClick={() => {
                              setIsLoading(true);
                              setIsContinue(true);
                              setSelectedLive(live);
                              _goLiveScreen(live, true);
                            }}
                            // className="hiddenActionCell btn-icon"
                            style={{
                              borderRadius: "6px",
                              color: "#422F90 ",
                              padding: "10px 0px 8px",
                              width: "99px",
                              height: "36px",
                              textAlign: "center",
                              background: "#F7F7F7",
                              marginLeft: 10,
                              border: "none",
                              borderColor: COLOR_APP,
                            }}>
                            <FontAwesomeIcon
                              icon={faVideo}
                              style={{ marginRight: 5 }}
                            />{" "}
                            ສຶບຕໍ່
                          </button>
                          <button
                            disabled
                            onClick={() => {
                              
                              try {
                                // Create a copy of the live object to avoid modifying the original
                                const liveCopy = { ...live };
                                delete liveCopy?.pageAccessToken;
                                delete liveCopy?.page;
                                delete liveCopy?.fbLiveId;
                                
                                //Convert obj to base64 (Unicode safe)
                                const jsonString = JSON.stringify(liveCopy);
                                const str = btoa(unescape(encodeURIComponent(jsonString)));
                                const marathonUrl = `/live-marathon/${str}`;
                                
                                // Open in new tab
                                const fullUrl = `${window.location.origin}${marathonUrl}`;
                                const newWindow = window.open(fullUrl, '_blank');
                                
                                if (!newWindow) {
                                  console.error("Failed to open new window - popup blocked?");
                                  addToast("Failed to open new tab. Please check popup blocker settings.", {
                                    appearance: "error",
                                    autoDismiss: true,
                                  });
                                } else {
                                  console.log("New tab opened successfully!");
                                  addToast("Marathon dashboard opened in new tab!", {
                                    appearance: "success",
                                    autoDismiss: true,
                                  });
                                }
                              } catch (error) {
                                console.error("Error in navigation:", error);
                                addToast("Navigation error: " + error.message, {
                                  appearance: "error",
                                  autoDismiss: true,
                                });
                              }
                              console.log("=== MARATHON BUTTON CLICK END ===");
                            }}
                            style={{
                              borderRadius: "6px",
                              color: "#fff",
                              padding: "10px 8px",
                              width: "120px",
                              height: "36px",
                              textAlign: "center",
                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              marginLeft: 10,
                              border: "none",
                              fontSize: "12px",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = "translateY(-1px)";
                              e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = "translateY(0)";
                              e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                            }}>
                            🏃‍♂️ Marathon(ໄວໆນີ້)
                          </button>
                          {/* &nbsp;&nbsp;
                          <CustomButton
                            onClick={() => handleCopyLinkLive(live)}
                            icon={<FaCopy />}
                            textStartLive={"ຄັດລ໋ອກລິ້ງ"}
                          /> */}
                        </div>
                      ) : live.status === PROCESSING ? (
                        <button
                          onClick={getLives}
                          style={{
                            marginLeft: 10,
                            background: "#F7F7F7",
                            borderRadius: "6px",
                            borderColor: "#F7F7F7",
                            color: COLOR_APP,
                            width: "36px",
                            height: "36px",
                            border: "none",
                          }}>
                          <FontAwesomeIcon icon={faRefresh} />
                        </button>
                      ) : (
                        <div
                          className="row-btn"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}>
                          {(updateLiveLoading && selectedLive?.id === live?.id) ? (
                            <button
                              disabled
                              style={{
                                background: "#F7F7F7",
                                color: "#422F90",
                                border: "1px solid #422F90",
                                borderRadius: "6px",
                                padding: "20px 0px",
                                display: "inline-flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "99px",
                                height: "36px",
                                minWidth: "110px",
                                position: "relative",
                                overflow: "hidden",
                                opacity: 0.9,
                              }}>
                              <div style={{ position: "relative", zIndex: 1, display: "inline-flex", alignItems: "center",gap:2 }}>
                                <FontAwesomeIcon icon={faVideo} />
                                &nbsp; ກຳລັງໂຫຼດ
                                <Spinner animation="border" size="sm" style={{ width: 15, height: 15, color: "#422F90" }} />
                              </div>
                            </button>
                          ) : (
                            <CustomButton
                              onClick={() => {
                                setSelectedLive(live);
                                setIsContinue(false);
                                _goLiveScreen(live, false);
                              }}
                              startLiveIcon
                              textStartLive={"ເລີ່ມໄລຟ໌"}
                            />
                          )}
                          &nbsp;&nbsp;
                          {/* <CustomButton
                            onClick={() => handleCopyLinkLive(live)}
                            icon={<FaCopy />}
                            textStartLive={"ກ໋ອບປິລິ້ງ"}
                          /> */}
                          <button
                            onClick={() => {
                              history.push(`/live-add`, {
                                editMode: true,
                                data: live,
                              });
                            }}
                            style={{
                              marginLeft: 10,
                              background: "#F7F7F7",
                              borderRadius: "6px",
                              borderColor: "#F7F7F7",
                              color: "green",
                              width: "36px",
                              height: "36px",
                              border: "none",
                            }}>
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            onClick={() => {
                              setDeleteData(live);
                              // setShowDeleteModal(true);
                              triggerShowDeleteLiveConfirm();
                            }}
                            style={{
                              marginLeft: 10,
                              background: "#F7F7F7",
                              borderRadius: "6px",
                              borderColor: "#F7F7F7",
                              color: "#D21C1C",
                              width: "36px",
                              height: "36px",
                              border: "none",
                            }}>
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                          {/* <button >
                          copy link
                        </button> */}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: width > 700 ? "space-between" : "center",
                alignItems: "center",
              }}>
              {liveTotal && width > 700 && (
                <div className="show">
                  ກຳລັງສະແດງ {30 * _skip - 29}-
                  {30 * _skip > liveTotal ? liveTotal : 30 * _skip} ຈາກ{" "}
                  {liveTotal}
                </div>
              )}
              <div>
                {Pagination_helper(liveTotal, "/live-manage/history", ``)}
              </div>
              <div />
            </div>
            <div
              style={{
                padding: "20px 0px 20px 16px",
                margin: "8px 24px 32px 23px",
              }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}></div>
            </div>
          </div>
        )}
      <BasicModal
        show={showDeleteLiveConfirm}
        onHide={triggerHideDeleteLiveConfirm}
        okay={handleDeleteLive}
        title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່"
        leftButtonName="ຍົກເລີກ"
        rightButtonName="ຕົກລົງ"
        Illustration={Illustration}
      />
      <SuccessModal
        show={showDeleteLiveSuccess}
        onHide={triggerHideDeleteLiveSuccess}
        title="ລຶບສຳເລັດ"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(LiveActive);
